import React from 'react';
import { useAddChoreForm } from '../hooks/useAddChoreForm';
import ChoreFormDialog from './ChoreFormDialog';

const AddChoreForm: React.FC<{ isOpen: boolean; onClose: () => void }> = ({ isOpen, onClose }) => {
  const {
    formData,
    setFormData,
    households,
    members,
    toggleAssignment,
    toggleResponsible,
    loading,
    isValid,
    handleSubmit,
    addAnother,
    setAddAnother,
  } = useAddChoreForm(isOpen, onClose);

  return (
    <ChoreFormDialog
      mode="add"
      open={isOpen}
      onClose={onClose}
      onSubmit={handleSubmit}
      values={formData}
      onChange={(field, value) => setFormData(prev => ({ ...prev, [field]: value }))}
      members={members}
      toggleAssignment={toggleAssignment}
      toggleResponsible={toggleResponsible}
      households={households.map(h => ({ id: h.household.id, name: h.household.name }))}
      householdId={formData.householdId}
      onHouseholdChange={(householdId) => setFormData(prev => ({ ...prev, householdId }))}
      addAnother={addAnother}
      onAddAnotherChange={setAddAnother}
      loading={loading}
      canSubmit={isValid}
    />
  );
};

export default AddChoreForm;
